import { useState } from 'react';
import { Modal } from 'antd';
import { FilePdfViewer } from './components/file-pdf-viewer';
import { IMAGE_MIME_TYPE_REGEXP, PDF_MIME_TYPE } from './constants';
import type { IFilePreviewProps } from './types';

export const FilePreview = (props: IFilePreviewProps) => {
  const { fileName, mimeType, getFileLink, renderTrigger } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fileLink, setFileLink] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);

  const handleOpen = async () => {
    setIsLoading(true);

    try {
      const result = await getFileLink();
      setFileLink(result.url);
      setIsModalOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const isImage = IMAGE_MIME_TYPE_REGEXP.test(mimeType);
  const isPdf = mimeType === PDF_MIME_TYPE;

  if (!isImage && !isPdf) return null;

  return (
    <>
      {renderTrigger({ isLoading, onClick: handleOpen })}
      <Modal title={fileName} open={isModalOpen} width={950} footer={null} onCancel={() => setIsModalOpen(false)}>
        {isModalOpen && fileLink && isPdf && <FilePdfViewer fileLink={fileLink} />}
        {isModalOpen && fileLink && isImage && <img src={fileLink} alt={fileName} style={{ maxWidth: '100%' }} />}
      </Modal>
    </>
  );
};
